import Content from "@/components/Content.tsx";
import WagerGamePage from "@/friendlyWagers/WagerGamePage.tsx";
import Header from "@/Header.tsx";
import {createFileRoute, useParams} from '@tanstack/react-router'
import React from "react";

/** One game's tips — where a Friendly Wagers push lands (WagerNotifier's navigate-to). */
export const Route = createFileRoute('/_app/friendly-wagers/$game_uid')({
    component: RouteComponent,
})

function RouteComponent() {
    const params = useParams({strict: false});
    return <>
        <Header />
        <Content>
            <WagerGamePage gameUid={params.game_uid!} />
        </Content>
    </>
}
